import*as React from"react";import styled from"@emotion/styled";const BadgesContainer=styled.div`
  display: inline-flex;
  align-content: center;
  justify-content: flex-start;
  align-items: center;

  flex-wrap: wrap;
  gap: 5px;
`;const PortfolioBadge=styled.span`
  width: max-content;
  height: 20px;
  border-radius: 64px;
  padding: 0 8px;

  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;

  display: inline-flex;
  align-content: center;
  justify-content: center;
  align-items: center;
`;const TaxFreePortfolioBadge=styled(PortfolioBadge)`
  background-color: ${props=>props.theme.colors.lime100};
  color: ${props=>props.theme.colors.lime800};
`;const ExternallyManagedPortfolioBadge=styled(PortfolioBadge)`
  background-color: ${props=>props.theme.colors.amber100};
  color: ${props=>props.theme.colors.amber800};
`;const RoboAdvisorPortfolioBadge=styled(PortfolioBadge)`
  background-color: ${props=>props.theme.colors.indigo100};
  color: ${props=>props.theme.colors.indigo800};
`;const CurrentPortfolioBadges=props=>{const hasBadges=props.portfolio.isTaxFree||props.portfolio.isExternallyManaged||props.portfolio.isInvestedFund;if(!hasBadges)return null;return React.createElement(BadgesContainer,null,props.portfolio.isTaxFree?React.createElement(TaxFreePortfolioBadge,null,"Tax-free"):null,props.portfolio.isExternallyManaged?React.createElement(ExternallyManagedPortfolioBadge,null,"Externally managed"):null,props.portfolio.isInvestedFund?React.createElement(RoboAdvisorPortfolioBadge,null,"Robo-advisor"):null)};export default CurrentPortfolioBadges;